import React, { Component } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import Dashboard from "./dashboard"
import Report from "./report"
import DataManage from "./data_manage"
import DataMangeDetail from "./data_manage_detail"

export default class extends Component {
  render () {
    const { match } = this.props
    return (
      <Switch>
        <Route path={`${match.url}/dashboard`} component={Dashboard} />
        <Route path={`${match.url}/report`} component={Report} />
        <Route exact path={`${match.url}/data_manage`} component={DataManage} />
        <Route path={`${match.url}/data_manage/:id`} component={DataMangeDetail}/>
        <Redirect from='*' to={`${match.url}/dashboard`} />
      </Switch>
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/pgd/index.js